export const GET_IS_DATA_FETCHED_REQUEST = "GET_IS_DATA_FETCHED_REQUEST";
export const GET_IS_DATA_FETCHED_SUCCESS = "GET_IS_DATA_FETCHED_SUCCESS";
export const GET_IS_DATA_FETCHED_FAILURE = "GET_IS_DATA_FETCHED_FAILURE";
